import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.object.keys";
import "core-js/modules/web.dom.iterable";
import _defineProperty from "E:\\01_WORK\\02_ClearTicket\\clearticket_pc\\node_modules\\@babel\\runtime-corejs2/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import '@/style/page.less';
import { createOrder, checkLogin } from '@/api';
import { mapState } from 'vuex';
import dayjs from 'dayjs';
import Steps from '@/components/Steps';
import PageTitle from '@/components/PageTitle';
export default {
  components: {
    Steps: Steps,
    PageTitle: PageTitle
  },
  data: function data() {
    var validatePhone = function validatePhone(rule, value, callback) {
      if (!value) {
        return callback(new Error('手机号码不能为空'));
      } else if (isNaN(value) || value.length !== 11) {
        callback(new Error('手机号码格式错误'));
      } else {
        callback();
      }
    };

    var validateIdentify = function validateIdentify(rule, value, callback) {
      if (!value) {
        return callback(new Error('身份证号不能为空'));
      } else if (value.length !== 15 && value.length !== 18) {
        callback(new Error('身份证号格式错误'));
      } else {
        callback();
      }
    };

    return {
      loading: false,
      form: {
        count: 1,
        buyer_name: '',
        buyer_phone: '',
        buyer_identify: '',
        remark: ''
      },
      rules: {
        buyer_name: [{
          required: true,
          message: '请输入姓名',
          trigger: 'blur'
        }],
        buyer_phone: [{
          required: true,
          validator: validatePhone,
          trigger: 'blur'
        }],
        buyer_identify: [{
          required: true,
          validator: validateIdentify,
          trigger: 'blur'
        }]
      },
      tickets: []
    };
  },
  computed: _objectSpread({}, mapState(['ticketInfo']), {
    totalPrice: function totalPrice() {
      return +this.ticketInfo.price * this.form.count;
    }
  }),
  watch: {
    'form.count': {
      handler: function handler(val) {
        while (this.tickets.length < val) {
          var ticket = {
            'guest_identify': '',
            'guest_name': '',
            'guest_phone': '',
            'play_date_begin': dayjs().format('YYYY-MM-DD'),
            'price': this.ticketInfo.price,
            'ticket_type_id': this.ticketInfo.id
          };
          this.tickets.push(ticket);
        }

        if (this.tickets.length > val) {
          this.tickets.splice(val, this.tickets.length);
        }
      },
      immediate: true
    }
  },
  mounted: function mounted() {
    var _this = this;

    checkLogin().then(function (res) {
      if (!res.data.extraInfo) {
        localStorage.removeItem('pc_token');

        _this.$router.push({
          name: 'login'
        });
      }
    });

    if (!this.ticketInfo.id) {
      this.$router.push({
        name: 'member'
      });
    }
  },
  methods: {
    toPayPage: function toPayPage() {
      var _this2 = this;

      this.$refs.buyerForm.validate(function (valid) {
        if (valid) {
          _this2.loading = true;

          _this2.tickets.forEach(function (t) {
            t.play_date_begin = dayjs().format('YYYY-MM-DD');
          });

          var params = {
            remark: _this2.form.remark,
            'buyer_identify': _this2.form.buyer_identify,
            'buyer_name': _this2.form.buyer_name,
            'buyer_papers_type': 'ID_CARD',
            'buyer_phone': _this2.form.buyer_phone,
            'price': _this2.totalPrice,
            'tickets': _this2.tickets
          };
          createOrder(params).then(function (res) {
            _this2.$router.push({
              name: 'ticketPay',
              params: {
                id: res.data.extraInfo.id
              }
            });
          }).finally(function () {
            _this2.loading = false;
          });
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    }
  }
};